import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import ReactGA from 'react-ga';
import { CookiesProvider } from 'react-cookie';
import { initializeIcons } from '@uifabric/icons';

import App from './pages/App';
import * as serviceWorker from './serviceWorker';
import { initializeLogRocket } from './services';
import './index.css';

initializeIcons();
initializeLogRocket();

ReactGA.initialize('UA-158806718-1', { titleCase: false });

ReactDOM.render(
  <CookiesProvider>
    <App />
  </CookiesProvider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
